<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <clientsidebar></clientsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div class="moduleCard">
            <div class="row">
              <div class="col-12 text-right">
                <button class="btn btn-secondary btn-medium" @click="doViewSent" id="view_sent">{{MModeButton}}</button>&nbsp;&nbsp;
                <button class="btn btn-secondary btn-medium" @click="doMessageSettings" id="message_settings">Message Settings</button>
              </div>
            </div>
            <div class="row mt-2" v-if="wtdata!==null">
              <div class="col-12" v-show="mmode===0">
                <wondertable :wtID="'myInbox'" :tcapiData="wtdata" :methods="wtmethods" :noRecords="noMessagesText" :defaultDirection="1"
                             :ids="wids" :hasExportExcel="'1'" :hasExportPDF="'1'" :title="inboxTitle" :burgerMenu="burgermenu"></wondertable>
              </div>
            </div>
            <div class="row mt-2" v-if="twtdata!==null">
              <div class="col-12" v-show="mmode===1">
                <div id="no_sent_messages">
                  <wondertable :wtID="'mySent'" :tcapiData="twtdata" :methods="twtmethods" :noRecords="'No Sent Messages'" :defaultDirection="1"
                               :ids="twids" :hasExportExcel="'1'" :hasExportPDF="'1'" :title="'Sent Messages'" :burgerMenu="tburgermenu"></wondertable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div style="display:none">
      <span id="inbox_title">Inbox</span>
      <span id="no_messages_text">You Have No Messages</span>
      <span id="new_message_text">New Message</span>
      <span id="date_text">Date</span>
      <span id="from_text">From</span>
      <span id="subject_text">Subject</span>


    </div>

    <acfooter></acfooter>
    <b-modal ref="uNoti" id="message_settings_modal"
             title="Message Settings" size="lg"
             @ok="saveMessageSettings">
      <div class="mb-3">
        <label id="personal_email" class="text-dark">Personal Email</label><br />
        <input class="checkbox" type="checkbox" v-model="addR" /><span id="duplicate_messages">&nbsp;&nbsp;Duplicate messages to my personal email address </span>

      </div>
      <div class="mb-3" v-show="addR===true">
        <label class="text-dark">Turn Off Messages</label><br />
        <input class="checkbox" type="checkbox" v-model="onlyE" />&nbsp;&nbsp;Messages will no longer appear in your inbox (you will still receive an email)
      </div>
    </b-modal>
  </div>
</template>

<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import clientsidebar from "../../layout/Client/Sidebar.vue"
  import wondertable from "../../components/WonderTable.vue"

  export default {
    name: 'CliInbox',
    components: { acheader, acfooter, clientsidebar, wondertable },
    data() {
      return {
        addR: null,
        inboxTitle: "Inbox",
        noMessagesText: "You Have No Messages",
        newMessageText: "New Message",
        burgermenu: [],
        tburgermenu: [],
        clnEmail: null,
        mmode: 0,
        MModeButton: "View Sent",
        onlyE: null,
        wids: [],
        wtdata: null,
        wtmethods: {
          newMessage: {
            method: function (param, ref) {
              ref.newMessage(param);
            },
            ref: this
          }
        },
        twids: [],
        twtdata: null,
        twtmethods: {}
      }
    },
    methods: {
      doViewSent() {
        if (this.mmode === 0) {
          this.mmode = 1;
          this.MModeButton = "View Inbox"
        }
        else {
          this.mmode = 0;
          this.MModeButton = "View Sent"
        }
      },
      doMessageSettings() {
        this.$refs["uNoti"].show();
      },
      newMessage() {
        this.$router.push("/client/newmessage/0");
      },
      saveMessageSettings() {
        if (this.clnEmail !== null) {
          this.apiCommand([{
            Operation: "Client",
            Function: "DeleteNotification",
            Fields: {
              ClientNotificationID: this.clnEmail
            }
          }]).then(response => {
            if (this.addR) {
              this.apiCommand([{
                Operation: "Client",
                Function: "AddNotification",
                Fields: {
                  NotificationID: "2a8646f5-158c-4328-a7b3-fd921032b0f8",
                  Frequency: 0,
                  ShouldEmail: "true",
                  OnlyEmail: this.onlyE ? "true" : "false"
                }
              }]).then(r => {
                this.popDialog(0, "Message Settings Saved");
                this.renderInbox();
              })
            }
            else {
              this.popDialog(0, "Message Settings Saved");
              this.renderInbox();
            }

          })
        }
        else {
          if (this.addR) {
            this.apiCommand([{
              Operation: "Client",
              Function: "AddNotification",
              Fields: {
                NotificationID: "2a8646f5-158c-4328-a7b3-fd921032b0f8",
                Frequency: 0,
                ShouldEmail: "true",
                OnlyEmail: this.onlyE ? "true" : "false"
              }
            }]).then(r => {
              this.popDialog(0, "Message Settings Saved");
              this.renderInbox();
            })
          }
        }
      },
      renderInbox() {
        this.apiCommand(
          [
            {
              Operation: "Client",
              Function: "GetMessages",
              Fields: {}
            },
            {
              Operation: "Client",
              Function: "GetSentMessages",
              Fields: {}
            },
            {
              Operation: "Client",
              Function: "GetNotifications",
              Fields: {}
            }
          ]).then(response => {

            var cr = JSON.parse(response.CommandResult);
            var mess = JSON.parse(cr.returnObjects[0].returnObject);
            var sent = JSON.parse(cr.returnObjects[1].returnObject);
            var noti = JSON.parse(cr.returnObjects[2].returnObject);

            this.addR = false;
            this.onlyE = false;

            for (var x = 0; x < noti.length; x++) {
              if (noti[x].NotificationID === "2a8646f5-158c-4328-a7b3-fd921032b0f8") {
                this.addR = true;
                this.clnEmail = noti[x].ClientNotificationID;
                if (noti[x].OnlyEmail === true) {
                  this.onlyE = true;
                }
              }
            }


            if (mess.length > 0) {

              for (var x = 0; x < mess.length; x++) {
                mess[x].Subject = "<a href='/client/message/" + mess[x].ClientMessageID + "'>" + mess[x].Subject + "</a>";
                if (mess[x].HasRead !== true) {
                  mess[x].Subject = "<b>" + mess[x].Subject + "</b>"
                }
              }

            }


            if (sent.length > 0) {

              for (var x = 0; x < sent.length; x++) {
                sent[x].Subject = "<a href='/client/message/" + sent[x].ClientMessageID + "'>" + sent[x].Subject + "</a>";

              }

            }

            this.bootstrapClient(this.$route.params.id);
            this.wtdata = mess;
            this.twtdata = sent;

          });

      },

      applyLocalization() {

        this.$nextTick(() => {

          Window.loadLanguageContent();

          setTimeout(() => {

            this.inboxTitle =
              document.getElementById("inbox_title")?.innerText || "Inbox";

            this.noMessagesText =
              document.getElementById("no_messages_text")?.innerText || "You Have No Messages";
            this.newMessageText =
              document.getElementById("new_message_text")?.innerText || "New Message";

            this.burgermenu = [[{
              html: this.newMessageText,
              value: "newMessage"
            }]];

          }, 300);
          try {

            const myInbox = document.getElementById("myInbox");

            if (myInbox) {

              const ths = myInbox.getElementsByTagName("th");

              for (let i = 0; i < ths.length; i++) {

                const txt = ths[i].innerText.trim();

                if (txt === "Date") {
                  ths[i].innerText =
                    document.getElementById("date_text")?.innerText || "Date";
                }

                if (txt === "From") {
                  ths[i].innerText =
                    document.getElementById("from_text")?.innerText || "From";
                }

                if (txt === "Subject") {
                  ths[i].innerText =
                    document.getElementById("subject_text")?.innerText || "Subject";
                }

              }

            }

          } catch (e) {
            console.error(e);
          }

        });

      }

    },
  



      mounted() {

      this.doPage().then(r => {

        this.renderInbox();

        this.$nextTick(() => {

          Window.loadLanguageContent();

          setTimeout(() => {

            this.inboxTitle =
              document.getElementById("inbox_title")?.innerText || "Inbox";

            this.noMessagesText =
              document.getElementById("no_messages_text")?.innerText || "You Have No Messages";
            this.newMessageText =
              document.getElementById("new_message_text")?.innerText || "New Message";

            this.burgermenu = [[{
              html: this.newMessageText,
              value: "newMessage"
            }]];

          }, 300);

        });

      });

    }
  }
   
</script>
